import { FC, useState } from 'react';

import { AnimatePresence, motion } from 'motion/react';

import { useAppDispatch } from '@/store/store';
import { hideNotification } from '@/store/slices/notificationsSlice';

import Logo from '@/assets/notification/logo.svg';

import { XMarkIcon } from '@heroicons/react/24/outline';

interface NotificationProps {
  id: number;
  title: string;
  message: string;
  is_read: boolean;
  url?: string;
  created_at: string;
}

const Notification: FC<NotificationProps> = ({
  id,
  title,
  message,
  url,
  is_read,
  created_at,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const dispatch = useAppDispatch();

  const handleHide = () => {
    setIsVisible(false);
    setTimeout(() => {
      dispatch(hideNotification(id));
    }, 300);
  };

  const handleOpenUrl = (link: string) => {
    if (!link) return;
    if (window.electron) {
      window.electron.send('open-url', link);
    } else {
      window.open(link, '_blank');
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          variants={{
            initial: { opacity: 1, x: 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, transition: { duration: 0.3 } },
          }}
          initial="initial"
          animate="animate"
          exit="exit"
          className={`
             flex mt-2 px-2 first:mt-0 
            border-l-[3px] transition-colors duration-300 
            ${!is_read ? 'border-[#C32025]' : 'border-white'}
          `}>
          <div className="mr-3 flex-shrink-0">
            <img src={Logo} className="w-[32px] h-[32px]" />
          </div>

          <div className="flex flex-col w-full gap-1">
            <div className="relative">
              <span className="font-jostMedium break-words pr-6">{title}</span>
              <XMarkIcon
                className="absolute top-1 right-0 w-[16px] h-[16px] stroke-3 text-gray-400 cursor-pointer hover:text-gray-500"
                onClick={handleHide}
              />
            </div>

            <p className="font-jostRegular text-[#1F2B40] break-words">
              {message}
            </p>

            <div className="flex items-center justify-between">
              <div className="min-w-[100px]">
                {url && (
                  <button
                    onClick={() => handleOpenUrl(url)}
                    className="cursor-pointer text-sm font-jostMedium text-[#1F2B40] underline">
                    læs mere
                  </button>
                )}
              </div>
              <span className="text-xs text-gray-400">
                {new Date(created_at).toLocaleDateString()}
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Notification;
